<h2 class="complete-profile-title flex items-center gap-2">
  <button class="cursor-pointer hover:text-primary" (click)="onBack.emit()"><i class="fa-light fa-square-arrow-left text-3xl"></i></button>
  Upload Profile Image
</h2>
<div class="relative">
  <div class="cursor-pointer uploader-template aspect-1 w-full min-h-[300px] overflow-hidden center-all border border-gray-200 rounded-lg" (click)="select()">
    @if (uploadedFile() != null) {
      <app-resized-image [src]="uploadedFile()!" [width]="600" [height]="600"></app-resized-image>
    } @else {
      @if (progress() > 0) {
        <div class="flex flex-col gap-4 center-all">
          <i class="fa-thin fa-spinner animate-spin text-4xl"></i>
          <small>{{ progress().toFixed(0) }} % Uploaded</small>
        </div>
      } @else {
        <span class="size-12 center-all bg-primary rounded-lg">
        <i class="fa fa-plus text-white rounded-lg"></i>
            </span>

      }
    }
  </div>
</div>
<button [disabled]="uploadedFile() == null" class="btn-base w-full bg-primary text-white mt-6" (click)="saved.emit()">Next</button>

<input
  #fileInput
  type="file"
  style="display: none;"
  accept=".jpg,.jpeg,.png,image/jpeg,image/png"
  (change)="onFileSelected($event)"
/>
